(function () {
    'use strict';

    angular
        .module('app.vendors')
        .controller('VendorsAddController', AddController);

    AddController.$inject = ['$location', 'VendorsService'];

    function AddController($location, Service) {

        /* jshint validthis:true */
        var vm = this;

        vm.title = '';

        vm.entity = {};

        vm.fields = Service.getFields();

        vm.create = function () {
            if (vm.form.$valid) {
                vm.loading = true;
                vm.entity.VendorTypeId = '3909332A-2A59-4FDB-BC69-69AD5D0ABCDC';
                Service.add(vm.entity).then(function (data) {
                    vm.loading = false;
                    $location.path('/vendors/detail/' + data.Id);
                });
            }
        };
    }
})();